<template>
	<div>
		<h1 class="left-align">Logs</h1>
		<v-container>
			<v-row>
				<v-col>
					<v-select
						:items="itemsLogType"
						v-model="logType"
						item-text="text"
						item-value="value"
						filled
						label="Log Type"
						item-color="black"
						@change="onLogTypeChange"
					></v-select>
				</v-col>
				<v-col>
					<v-select
						:items="itemsLogSource"
						v-model="logSource"
						item-text="text"
						item-value="value"
						filled
						label="Log Source"
						item-color="black"
						ref="firstFocus"
					></v-select>
				</v-col>
				<v-col>
					<v-select
						:items="itemsLogMonth"
						v-model="logMonth"
						item-text="text"
						item-value="value"
						filled
						label="Month"
						item-color="black"
					></v-select>
				</v-col>
				<v-col>
					<v-text-field
						label="Year"
						v-model="logYear"
					></v-text-field>
				</v-col>
				<v-col>
					<v-btn
						class="btn-default"
						text
						@click="getLogs()"
						:loading="isLoading"
					>Search</v-btn>
					<v-btn
						class="btn-default"
						text
						@click="clearFilters()"
					>Clear</v-btn>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-text-field
						label="User"
						v-model="logUserName"
					></v-text-field>
				</v-col>
				<v-col>
					<v-select
						:items="itemsLogLevel"
						v-model="logLevel"
						item-text="text"
						item-value="value"
						filled
						label="Level"
						item-color="black"
						v-if="logType === 'LOGS'"
					></v-select>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-data-table
						:headers="getHeaders"
						:items="logsList.data"
						:server-items-length="logsList.total"
						:loading="isLoading"
						:options.sync="dataTableOptions"
						@update:options="onUpdateOptions"
					>
						<template v-for="h in getHeaders" v-slot:[`header.${h.value}`]="{ header }">
							<span :key="h.value" class="columnTitleText" tabIndex="0" v-on:keyup.enter="(e) => e.target.click()">{{h.text}}</span>
						</template>
					</v-data-table>
				</v-col>
			</v-row>
		</v-container>
		<br/>
		<!-- <v-data-table
			:headers="headers"
			:items="logsList"
			item-key="userName"
			show-select
			class="elevation-1"
			:page.sync="page"
			:items-per-page="itemsPerPage"
			hide-default-footer
			@page-count="pageCount = $event"
			:loading="isLoading"
		>
		</v-data-table> -->
	</div>
</template>

<script>
import { researcherApiService } from '@/services/researcherApiService.js';
import { LogTypes } from '@/common/LogTypes.js'

export default {
	name: 'Logs',
	data: () => ({
		logsList: {
			data: [],
			total: 0
		},
		logType: LogTypes.AuditTrail,
		logSource: null,
		logLevel: null,
		logMonth: null,
		logYear: null,
		logUserName: null,
		headersLogs: [
			{ text: 'User', value: 'userName', hover: '', class: 'data-table-header' },
			{ text: 'Date', value: 'dateRecorded', hover: '', class: 'data-table-header' },
			{ text: 'Level', value: 'levelName', hover: '', class: 'data-table-header' },
			{ text: 'Message', value: 'message', hover: '', class: 'data-table-header', sortable: false }
		],
		headersAuditTrail: [
			{ text: 'User', value: 'userName', hover: '', class: 'data-table-header' },
			{ text: 'Method', value: 'method', hover: '', class: 'data-table-header' },
			{ text: 'Endpoint', value: 'url', hover: '', class: 'data-table-header' },
			{ text: 'Response', value: 'status', hover: '', class: 'data-table-header' },
			{ text: 'Time', value: 'dateTimeStart', hover: '', class: 'data-table-header' },
			{ text: 'Duration', value: 'duration', hover: '', class: 'data-table-header' }
		],
		itemsLogType: [
			{ text: 'Audit Trail', value: LogTypes.AuditTrail },
			{ text: 'Logs', value: LogTypes.Logs }
		],
		itemsLogSource: [
			{ text: 'Researcher Site', value: 'RESEARCHER' },
			{ text: 'Respondent Site', value: 'RESPONDENT' },
			{ text: 'Analysis Service', value: 'ANALYSIS' }
		],
		itemsLogMonth: [
			{ text: 'January', value: 'JANUARY' },
			{ text: 'February', value: 'FEBRUARY' },
			{ text: 'March', value: 'MARCH' },
			{ text: 'April', value: 'APRIL' },
			{ text: 'May', value: 'MAY' },
			{ text: 'June', value: 'JUNE' },
			{ text: 'July', value: 'JULY' },
			{ text: 'August', value: 'AUGUST' },
			{ text: 'September', value: 'SEPTEMBER' },
			{ text: 'October', value: 'OCTOBER' },
			{ text: 'November', value: 'NOVEMBER' },
			{ text: 'December', value: 'DECEMBER' }
		],
		itemsLogLevel: [
			{ text: 'ALL', value: null },
			{ text: 'ERROR', value: 'ERROR' },
			{ text: 'WARN', value: 'WARN' },
			{ text: 'INFO', value: 'INFO' },
			{ text: 'DEBUG', value: 'DEBUG' },
			{ text: 'TRACE', value: 'TRACE' }
		],
		itemsPerPage: 15,
		page: 1,
		isLoading: false,
		dataTableOptions: {
			sortBy: ['dateTimeStart'],
			sortDesc: [true],
			page: 1,
			itemsPerPage: 15
		}
	}),
	mounted () {
		// Set default values for filters
		this.clearFilters();
	},
	computed: {
		getHeaders: function () {
			if (this.logType === LogTypes.AuditTrail) {
				return this.headersAuditTrail;
			} else {
				return this.headersLogs;
			}
		}
	},
	methods: {
		onUpdateOptions: function () {
			this.getLogs();
		},
		onLogTypeChange: function (value) {
			if (value === LogTypes.Logs) {
				this.dataTableOptions = {
					sortBy: ['dateRecorded'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15
				};
			} else {
				this.dataTableOptions = {
					sortBy: ['dateTimeStart'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15
				};
			}
		},
		getLogs: function () {
			const me = this;
			this.isLoading = true;

			let sortString = 'dateTimeStart';
			if (this.dataTableOptions.sortBy != null && this.dataTableOptions.sortBy.length > 0) {
				sortString = this.dataTableOptions.sortBy[0];
			}

			if (this.logType === 'LOGS') {
				researcherApiService.getLogs(this.dataTableOptions.page, this.dataTableOptions.itemsPerPage,
					sortString, this.dataTableOptions.sortDesc[0], this.logSource, this.logMonth, this.logYear, this.logUserName, this.logLevel).then(response => {
					me.logsList.data = response.data.data.result;
					me.logsList.total = response.data.data.total;
					me.isLoading = false;
				}).catch(error => {
					me.logsList.data = [];
					me.logsList.total = 0;
					me.isLoading = false;
					me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'generic-error', message: 'There was an error loading the log history' });
				});
			} else if (this.logType === 'AUDIT_TRAIL') {
				researcherApiService.getAuditTrail(this.dataTableOptions.page, this.dataTableOptions.itemsPerPage,
					sortString, this.dataTableOptions.sortDesc[0], this.logSource, this.logMonth, this.logYear, this.logUserName).then(response => {
					me.logsList.data = response.data.data.result;
					me.logsList.total = response.data.data.total;
					me.isLoading = false;
				}).catch(error => {
					me.logsList.data = [];
					me.logsList.total = 0;
					me.isLoading = false;
					me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'generic-error', message: 'There was an error loading the audit trail history' });
				});
			}
		},
		clearFilters: function () {
			const d = new Date();
			this.logSource = this.itemsLogSource[0].value;
			this.logMonth = this.itemsLogMonth[parseInt(d.getMonth())].value;
			this.logYear = d.getFullYear();
			this.logUserName = null;
			this.logLevel = this.itemsLogLevel[0].value;
		}
	}
}
</script>

<style>

</style>
